
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import StepList from "@/components/scope/step-list.vue";
import { InjectFunction } from "@common/src/utils/decorator";
import TransferPrint from "./components/transfer-print.vue";
import t from "@common/src/i18n/t";
const common_inventory = namespace("common_inventory");
const app = namespace("app");
const setting = namespace("setting");

@InjectFunction("dayjs", "addCurrencyUnit", "emptyToLine", "splitThousands", "permit", "permitApp", "partsPropComb")
@Component({
  components: {
    StepList,
    TransferPrint
  }
})
export default class ServiceView extends Vue {
  @common_inventory.Action comfirmTransferWarehouse;
  @common_inventory.Action cancelTransferWarehouse;
  @common_inventory.Action queryTransferWarehouseDetail;
  @app.State btnLoading;
  @app.Mutation btnStartLoading;
  @app.Mutation btnStopLoading;
  @setting.State fifoStatus;
  @setting.State productionBatchNoStatus;
  orderList: any[] = [];
  get breadData() {
    return [
      { name: t("v210.warehouse-transfer-management"), path: "/inventory/transfer-warehouse-list" },
      { name: t("v210.details-of-stock-transfer-order") }
    ];
  }
  created() {
    this.init();
  }
  handleMoreMenuClick(command) {
    if (command === "cancel") {
      this.cancelTransferWarehouse({
        transferCode: this.orderId
      }).then(() => {
        this.$message.success(t("finance.cancel-success") as string);
        this.init();
      });
    }
  }
  get orderId() {
    return this.$route.params.id;
  }
  detailData: any = { inboundStatus: "2", photoList: [] };

  init() {
    this.queryTransferWarehouseDetail({
      transferCode: this.orderId
    }).then(data => {
      this.detailData = data.data;
    });
  }
  showTransferPrint: boolean = false;
  orderPrintObj: any = {
    id: "printMer1",
    popTitle: t("v210.stock-transfer-sheet-printing"),
    extraCss: "",
    extraHead: '<meta http-equiv="Content-Language"content="zh-cn"/>'
  };
  handlePrint() {
    this.showTransferPrint = true;
  }
  showInConfirmTips: boolean = false;
  handleShowConfirmDialog() {
    this.showInConfirmTips = true;
  }
  handleConfirmTransfer() {
    this.btnStartLoading();
    this.comfirmTransferWarehouse({
      transferCode: this.orderId
    })
      .then(() => {
        this.$message.success(t("v210.stock-transfer-doc-moved"));
        this.showInConfirmTips = false;
        this.init();
      })
      .finally(() => {
        this.btnStopLoading();
      });
  }
}
